export default {"src":"/_next/static/media/sofia.855dfacb.svg","height":80,"width":184,"blurWidth":0,"blurHeight":0};